"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _ShareIcons = _interopRequireDefault(require("./ShareIcons"));

var ShareBanner =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ShareBanner, _Component);

  function ShareBanner() {
    (0, _classCallCheck2.default)(this, ShareBanner);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ShareBanner).apply(this, arguments));
  }

  (0, _createClass2.default)(ShareBanner, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "share-banner"
      }, _react.default.createElement("div", {
        className: "share-banner-content"
      }, _react.default.createElement("span", {
        className: "share-banner-header"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "results.share.banner.title"
      }), _react.default.createElement("span", {
        className: "share-banner-paragraph"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "results.share.banner.description"
      }))), _react.default.createElement("div", {
        className: "share-banner-buttons"
      }, _react.default.createElement(_ShareIcons.default, null))));
    }
  }]);
  return ShareBanner;
}(_react.Component);

var _default = ShareBanner;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/ShareBanner.js
// module id = 307
// module chunks = 0